import { FC, type JSX } from 'react';
import { TripEventDrawerContent } from './components/trip-event-drawer-content';
import { getTripHistoryModeConfig, useTripHistoryViewMode } from './trip-history-base-controller';
import { TripHistoryDesktopViewController } from './trip-history-desktop-view-controller';
import { TripHistoryMobileViewController } from './trip-history-mobile-view-controller';

export { TripEventDrawerContent };

export const TripHistoryBaseViewController: FC = (): JSX.Element => {
  const viewMode = useTripHistoryViewMode();

  if (viewMode === 'mobile') {
    return <TripHistoryMobileViewController />;
  }

  const modeConfig = getTripHistoryModeConfig('desktop');
  return <TripHistoryDesktopViewController autoSelectFirstTrip={modeConfig.autoSelectFirstTrip} mobileLayout={modeConfig.mobileLayout} />;
};
